var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AuthenticationReason, AuthenticationResult, AuthenticationStatus, ThreeDsStatus } from '@mc-alberta/types';
import { Adapter } from '../Adapter';
import { AuthenticationStrategy } from '../../types/enums/AuthenticationStrategy';
import getThreeDsBrowserData from '../../methods/getThreeDsBrowserData';
import { KpiOperation } from '../../types/enums/KpiOperation';
import { LifecycleAwaitable, LifecycleAwaiting } from '../../decorators/LifecycleAwaiter';
import { VERIFICATION_METHOD } from '../../constants';
/**
 * Low-value, low-risk authentication.
 *
 * This is a frictionless strategy.
 * If a challenge is required, LVLR won't apply.
 */
export class LvlrAdapter extends Adapter {
    constructor() {
        super(...arguments);
        this.strategy = AuthenticationStrategy.LVLR;
        this.verificationMethods = [VERIFICATION_METHOD.LVLR];
        this.supportedReasons = [AuthenticationReason.TRANSACTION_AUTHENTICATION];
        this.selectedMethodIndex = 0;
        this.getLookupContext = () => __awaiter(this, void 0, void 0, function* () { return ({}); });
        this.provideChallenge = () => this.getSession();
        this.validateSession = () => this.getSession();
        this.setMethodAttributes = () => { };
    }
    /**
     * Attempts to authenticate using the low-value, low-risk strategy.
     */
    preloadSession() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            this.kpi.start(KpiOperation.INITIATE_AUTHENTICATION);
            const session = yield this.refreshSession({
                threeDsData: {
                    threeDsInputData: Object.assign(Object.assign({}, (_a = this.authenticationContext.dpaTransactionOptions) === null || _a === void 0 ? void 0 : _a.threeDsInputData), { browser: Object.assign(Object.assign({}, getThreeDsBrowserData()), { threeDSCompInd: ThreeDsStatus.Failure }) })
                }
            });
            if (session.authenticationResult === AuthenticationResult.NOT_AUTHENTICATED) {
                this.authenticationStatus = AuthenticationStatus.NOT_SUPPORTED;
            }
            return this.getSession();
        });
    }
    initializeSession(params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.authenticationSessionId) {
                return this.preloadSession();
            }
            if (params.isIdentityVerificationRequired) {
                // need a challenge
                return this.getNotSupportedResult();
            }
            return this.getSession();
        });
    }
}
__decorate([
    LifecycleAwaitable,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], LvlrAdapter.prototype, "preloadSession", null);
__decorate([
    LifecycleAwaiting('preloadSession'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], LvlrAdapter.prototype, "initializeSession", null);
